import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { StorageRepository, StorageResult } from '@okcargo-apps/shared-domain';

@Injectable({
  providedIn: 'root',
})
export class CapacitorStorageService implements StorageRepository {
  public async create(key: string, value: string): Promise<void> {
    await Preferences.set({ key, value });
  }

  public async read(key: string): Promise<StorageResult> {
    return Preferences.get({ key });
  }

  public async update(key: string, value: string): Promise<void> {
    await Preferences.set({ key, value });
  }

  public async delete(key: string): Promise<void> {
    await Preferences.remove({ key });
  }

  public async clear(): Promise<void> {
    await Preferences.clear();
  }
}
